import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    height: var(--split-height, 90vh);
  }
`;

export const LeftSide = styled.div`
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: var(--split-left-width, 58%);
    height: 100%;
    flex-shrink: 0;
  }
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${space[5]} ${space[4]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: var(--split-right-width, 42%);
    height: 100%;
    overflow: hidden;
    padding: ${space[6]} ${space[7]};
    box-sizing: border-box;
  }
`;

export const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: 1;
  min-height: 0;
`;
